import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from 'app/services/http/token-interceptor.service';
import { BaseurlHttpInterceptor } from 'app/services/http/baseurl-http-interceptor.service';
import { ErrorHttpInterceptor } from 'app/services/http/error-http-interceptor.service';
// import { AdHttpInterceptor } from 'app/modules/ad/http-interceptors/ad.http.interceptor';
import { CampaignHttpInterceptor } from 'app/modules/campaign/http-interceptors/campaign.http.interceptor';
import { CampaignFolderHttpInterceptor } from 'app/modules/campaign/http-interceptors/campaignfolder.http.interceptor';
import { CircuitHttpInterceptor } from 'app/modules/circuit/http-interceptors/circuit.http.interceptor';
import { TableParamsHttpInterceptor } from 'app/modules/common/table/table-params.http.interceptor';
import { CustomerHttpInterceptor } from 'app/modules/customer/http-interceptors/customer.http.interceptor';
import { DistributionHttpInterceptor } from 'app/modules/distribution/http-interceptors/distribution.http.interceptor';
import { ExportHttpInterceptor } from 'app/modules/export/http-interceptors/export.http.interceptor';
import { FeedHttpInterceptor } from 'app/modules/feed/http-interceptors/feed.http.interceptor';
import { FolderHttpInterceptor } from 'app/modules/folder/http-interceptors/folder.http.interceptor';
import { LocationsHttpInterceptor } from 'app/modules/locations/http-interceptors/locations.http.interceptor';
import { SystemHttpInterceptor } from 'app/modules/system/http-interceptors/system.http.interceptor';
import { TriggerHttpInterceptor } from 'app/modules/trigger/http-interceptors/trigger.http.interceptor';
import { UserHttpInterceptor } from 'app/modules/user/http-interceptors/user.http.interceptor';
import { FeeditemHttpInterceptor } from '../feed/http-interceptors/feeditem.http.interceptor';

export const GLOBAL_HTTP_INTERCEPTORS = [
  // ENVIRONMENT
  { provide: HTTP_INTERCEPTORS, useClass: BaseurlHttpInterceptor, multi: true },
  // SERVER ERRORS: 401 -> force logout, other: show toastr error
  { provide: HTTP_INTERCEPTORS, useClass: ErrorHttpInterceptor, multi: true },
  // TOKEN: add token to request
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  // TABLE PARAMS: add cached table params to request
  { provide: HTTP_INTERCEPTORS, useClass: TableParamsHttpInterceptor, multi: true },
  // ENTITIES TRANSFORMERS
  { provide: HTTP_INTERCEPTORS, useClass: SystemHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: TriggerHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: FeedHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: FeeditemHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: DistributionHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ExportHttpInterceptor, multi: true },
  // { provide: HTTP_INTERCEPTORS, useClass: AdHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: CustomerHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: FolderHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LocationsHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: CircuitHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: UserHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: CampaignHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: CampaignFolderHttpInterceptor, multi: true },
];
